export default {
    createStatusNotificationSuccess: 'Die Statusbenachrichtigung wurde erfolgreich erstellt.',
    createStatusNotification: 'Statusbenachrichtigung erstellen',
}